define 'controller/CategoryPillsController', ['jquery', 'lib/swiper-bundle.min'], ($) ->
  class CategoryPillsController

    constructor: (@$el) ->
      $slider = $('[data-controller-element=pills-swiper-container]')

      if $slider.length > 0
        startPosition = $slider.find('.category__sub-navigation__pill.active').index()

        @swiper = new Swiper $slider[0],
          initialSlide: startPosition,
          spaceBetween: 16,
          slidesPerView: 'auto',
          slidesPerGroupAuto: true,
          centerInsufficientSlides: true,
          speed: 1500,
          grabCursor: true,
          navigation: {
            nextEl: '.slider-nav__next',
            prevEl: '.slider-nav__prev'
          }

        $slider.find('.category__sub-navigation__pill').on 'click', (e) ->
          e.stopPropagation()
          e.preventDefault()

          url = new URL(e.currentTarget.href)
          url.searchParams.set('subcategory', $slider.data('startposition'))
          window.location = url